// Message Origin
const origin = "*";

// Handle view event
export const sendGoogleAnalyticsEvent = (eventName: string, property: string, metricName: string) => {
    window.parent.postMessage(
        {
            message: "sendGoogleAnalyticsEvent",
            data: {
                eventName,
                property,
                metricName
            }
        },
        origin
    );
    console.log("Google Analytics Event message sent:", { 'event': eventName, 'property': property, 'metricName': metricName });
}